import { Lock } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Styles from './CampaignDetailsModal.module.scss'

/** Footer of the details of an item discount Yassir created: view only (EXSR-8095). */
const CampaignDetailsReadOnlyNote = () => {
  const { t } = useTranslation()

  return (
    <div className={Styles.readOnlyNote} data-testid="campaign-read-only-note">
      <Lock width={14} height={14} aria-hidden />
      <span>{t('marketing.campaigns.details.managed-by-yassir')}</span>
    </div>
  )
}

export default CampaignDetailsReadOnlyNote
